export const getGlobalConfig = state => state.globalConfig;
export const getGlobalConfigField = (state, field) => {
  const globalConfig = getGlobalConfig(state);

  return globalConfig[field] || null;
};
